import { DOCUMENT_JOB_FAILED_STATUSES } from '@numeo/types-core'

/** The Document Jobs `status` filter for "failed at either stage": the list endpoint takes statuses separated by commas. */
export const FAILED_STATUS_FILTER = DOCUMENT_JOB_FAILED_STATUSES.join(',')
